const chartColors = ['#0047BB', '#050139', '#8C959B', '#F68D2E', '#65BD18', '#00A9E0']

const trimKey = (key, maxLength) => {
  return key.length > maxLength ? key.slice(0, maxLength - 3) + "..." : key;
};  

export function labelPrependAsType(type, ccy) {
  if (type === 'b') {
    return currencySymbol(ccy)
  } else {
    return ''
  }
}

export function labelAppendAsType(type) {
  switch (type) {
    case '%':
      return '%'
    case 'b':
      return 'B'
    case '%100':
      return '%'
    default:
      return ''
  }
}

export function valueAsType(value, type) {
  switch (type) {
    case '.':
      return value.toFixed(2)
    case '%':
      return value.toFixed(2)
    case '100%':
      return (value * 100).toFixed(2)
    case '.000%':
      return value.toFixed(4)
    case '%100':
      return (value * 100).toFixed(2)
    case 'b':
      return (value / 1000000000.0).toFixed(2)
    case '0':
      return value.toFixed(0)        
    case '':
      return value.toFixed(2)      
    default:
      return value
  }
}

export function normalize(val, minmax) {
  if (!minmax) {
    return val
  }

  if (val < minmax[0]) {
    return undefined
  } else if (val > minmax[1]) {
    return undefined
  } else {
    return val
  }
}

function getLegendData(data) {
  return data.map(fund => {
    return fund.ticker
  })
}

function hasEquity(data) {
  const equities = data.filter(function (value) {
    return value.fundCategoryTier1 && value.fundCategoryTier1.includes('Equity')
  })
  return equities.length > 0
}

//aggregateFundamentals
function getXData(data, name) {
  const hasEq = hasEquity(data)
  let xData = []
  let dateCnt = 0

  for (let x = 0; x < data.length; x++) {
    const actData = data[x][name]
    // don't include benchmark if we have equities so oldest fund is the max dates to show
    if (!actData || (hasEq && data[x].fundCategoryTier1 === 'Benchmarks')) {
      continue
    }
    if (actData.length > dateCnt) {
      dateCnt = actData.length
      xData = actData.map(item => {
        const date = new Date(item.date)
        return `${date.getMonth() + 1}/${date.getFullYear()}`
      })
    }
  }
  return xData
}

function getSeriesData(data, xData, aggregate, name, type, minmax) {
  const sData = []
  for (let d = 0; d < data.length; d++) {
    const aggs = data[d][aggregate]
    if (!aggs) {
      continue
    }
    const ticker = data[d].ticker
    // map agg date values to xAxis dates
    const values = xData.map(xDate => {
      const index = aggs.findIndex(agg => {
        const date = new Date(agg.date)
        return xDate === `${date.getMonth() + 1}/${date.getFullYear()}`
      })
      if (index > -1) {
        const valIndex = aggs[index].keys.findIndex(x => x === name)
        if (valIndex !== -1) {
          return normalize(valueAsType(aggs[index].values[valIndex], type), minmax)
        } else {
          return undefined
        }
      } else {
        return undefined
      }
    })
    // create and add the series object
    sData.push({
      name: ticker,
      type: 'line',
      smooth: true,
      symbol: 'none',
      itemStyle: {
        normal: {
          lineStyle: {
            width: 2
          }
        }
      },
      data: values
    })
  }
  return sData
}

export function getCharGraph(displayName, name, type, minmax, data) {
  // popoulate legend data
  const legendData = getLegendData(data)

  // populate xaxis data
  const xaxisData = getXData(data, 'aggregateFundamentals')

  // set series values
  const seriesData = getSeriesData(data, xaxisData, 'aggregateFundamentals', name, type, minmax)

  // create the chart option with data
  return {
    title: {
      text: '',
      left: 5,
      textStyle: {
        fontStyle: 'normal',
        fontWeight: 900,
        fontSize: 14,
        color: '#8C959B'
      }
    },
    tooltip: tooltipAsType(type),
    legend: {
      itemGap: 20,
      data: legendData
    },
    grid: {
      left: '3%',
      right: '3%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      axisLabel: {
        fontSize: 12,
        color: '#8C959B',
        rotate: 45,
        align: 'right'
      },
      data: xaxisData
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        fontSize: 12,
        color: '#8C959B',
        formatter: `${labelPrependAsType(type)}{value}${labelAppendAsType(type)}`
      }
    },
    series: seriesData,
    color: chartColors
  }
}

export function getSectorChart(data) {
  // popoulate legend data
  const legendData = getLegendData(data)

  // populate xaxisData
  const sectors = data.map(fund => {
    if (fund.sectorExposures) {
      return fund.sectorExposures[fund.sectorExposures.length - 1].keys
    } else {
      return null
    }
  })

  const allSectors = [].concat(...sectors)
  const uniqueSectors = allSectors.filter((v, i, a) => a.indexOf(v) === i)
  const xaxisData = [...uniqueSectors].sort()
  // set series data
  const seriesData = []
  for (let d = 0; d < data.length; d++) {
    if (!data[d].sectorExposures) {
      continue
    }
    const sects = data[d].sectorExposures[data[d].sectorExposures.length - 1]
    const ticker = data[d].ticker
    const values = xaxisData.map(name => {
      const index = sects.keys.findIndex(x => x === name)
      if (index !== -1) {
        return parseFloat((sects.values[index] * 100).toFixed(2))
      } else {
        return 0
      }
    })

    seriesData.push({ name: ticker, type: 'bar', barGap: 0, data: values })
    //console.log ('SECTOR --HH',seriesData)
  }

  // create the chart option with data
  return {
    legend: {
      itemGap: 20,
      data: legendData
    },
    tooltip: {
      trigger: 'axis',
      formatter: function (params) {
        let res = params[0].name
        for (let i = 0, l = params.length; i < l; i++) {
          res += `<br/>${params[i].marker} ${params[i].seriesName} : ${params[i].value}%`
        }
        return res
      },
      backgroundColor: '#FFF',
      borderWidth: 1,
      borderColor: '#050139',
      borderRadius: 0,
      textStyle: {
        color: '#5B6770',
        align: 'left'
      }
    },
    grid: {
      left: '3%',
      right: '3%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        axisLabel: {
          fontSize: 12,
          color: '#8C959B',
          rotate: 45,
          interval: 0,
          align: 'right',
          formatter: function (param) {
            return param.replace('&amp;', '&')
          }
        },
        axisPointer: {
          type: 'shadow'
        },
        data: xaxisData
      }
    ],
    yAxis: [
      {
        type: 'value',
        axisLabel: {
          fontSize: 12,
          color: '#8C959B',
          formatter: '{value}%'
        }
      }
    ],
    series: seriesData,
    color: chartColors
  }
}

export function getSoeSectorChart(data) {
  // popoulate legend data
  const legendData = getLegendData(data)

  // populate xaxisData
  const sectors = data.map(fund => {
    if (fund.sectorExposures) {
      return fund.sectorExposures[fund.sectorExposures.length - 1].keys
    } else {
      return null
    }
  })

  const allSectors = [].concat(...sectors)
  const uniqueSectors = allSectors.filter((v, i, a) => a.indexOf(v) === i)
  const xaxisData = [...uniqueSectors].sort()
  // set series data
  const seriesData = []
  const seriesData2 = [
    {
      name: '500',
      type: 'bar',
      // "stack": "soe",
      barGap: 0,
      data: [8.81, 10.89, 6.49, 4.8, 11.24, 14.38, 7.76, 27.09, 2.79, 0, 2.77, 2.98]
    },
    {
      name: 'EPS',
      type: 'bar',
      // "stack": "soe",
      barGap: 0,
      data: [10.76, 9.62, 7.33, 3.69, 15.22, 15.72, 6.53, 24, 2.91, 0.06, 1.54, 2.6]
    },
    {
      name: 'EZM',
      type: 'bar',
      // "stack": "soe",
      barGap: 0,
      data: [3.18, 17.15, 3.27, 5.79, 19.51, 8.25, 13.68, 12.02, 8.93, 0.29, 4.4, 3.54]
    }
  ]

  for (let d = 0; d < data.length; d++) {
    if (!data[d].sectorExposures) {
      continue
    }
    const sects = data[d].sectorExposures[data[d].sectorExposures.length - 1]
    const ticker = data[d].ticker
    const values = xaxisData.map(name => {
      const index = sects.keys.findIndex(x => x === name)
      if (index !== -1) {
        return parseFloat((sects.values[index] * 100).toFixed(2))
      } else {
        return 0
      }
    })
    seriesData.push({ name: ticker, type: 'bar', barGap: 0, data: values })
  }

  // create the chart option with data
  return {
    legend: {
      itemGap: 20,
      data: legendData
    },
    tooltip: {
      trigger: 'axis',
      formatter: function (params) {
        let res = params[0].name
        for (let i = 0, l = params.length; i < l; i++) {
          res += `<br/>${params[i].marker} ${params[i].seriesName} : ${params[i].value}%`
        }
        return res
      },
      backgroundColor: '#FFF',
      borderWidth: 1,
      borderColor: '#050139',
      borderRadius: 0,
      textStyle: {
        color: '#5B6770',
        align: 'left'
      }
    },
    grid: {
      left: '3%',
      right: '3%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        axisLabel: {
          fontSize: 12,
          color: '#8C959B',
          rotate: 45,
          interval: 0,
          align: 'right',
          formatter: function (param) {
            return param.replace('&amp;', '&')
          }
        },
        axisPointer: {
          type: 'shadow'
        },
        data: xaxisData
      }
    ],
    yAxis: [
      {
        type: 'value',
        axisLabel: {
          fontSize: 12,
          color: '#8C959B',
          formatter: '{value}%'
        }
      }
    ],
    series: seriesData2,
    color: chartColors
  }
}
export function getEsgChart(data) {
  // popoulate legend data
  const legendData = getLegendData(data)

  // populate xaxisData
  const riskCat = data.map(fund => {
    if (fund.esgOverallRiskMetrics) {
      return fund.esgOverallRiskMetrics[fund.esgOverallRiskMetrics.length - 1].keys
    } else {
      return null
    }
  })

  const allRiskCat = [].concat(...riskCat)
  const uniqueRiskCat = allRiskCat.filter((v, i, a) => a.indexOf(v) === i)
  let xaxisData = [...uniqueRiskCat]
  // set series data
  const seriesData = []
  for (let d = 0; d < data.length; d++) {
    if (!data[d].esgOverallRiskMetrics) {
      continue
    }
    const sects = data[d].esgOverallRiskMetrics[data[d].esgOverallRiskMetrics.length - 1]
    const ticker = data[d].ticker
    const values = xaxisData.map(name => {
      const index = sects.keys.findIndex(x => x === name)
      if (index !== -1) {
        return parseFloat((sects.values[index] * 100).toFixed(2))
      } else {
        return 0
      }
    })
    seriesData.push({ name: ticker, type: 'bar', barGap: 0, data: values })
  }

  //Format Axis Data
  xaxisData = xaxisData.map(name => {
    if (name === 'riskNegligible') {
      return 'Negligible Risk'
    } else if (name === 'riskLow') {
      return 'Low Risk'
    } else if (name === 'riskMedium') {
      return 'Medium Risk'
    } else if (name === 'riskHigh') {
      return 'High Risk'
    } else if (name === 'riskSevere') {
      return 'Severe Risk'
    } else {
      return name
    }
  })

  // create the chart option with data
  return {
    legend: {
      itemGap: 20,
      data: legendData
    },
    tooltip: {
      trigger: 'axis',
      formatter: function (params) {
        let res = params[0].name
        for (let i = 0, l = params.length; i < l; i++) {
          res += `<br/>${params[i].marker} ${params[i].seriesName} : ${params[i].value}%`
        }
        return res
      },
      backgroundColor: '#FFF',
      borderWidth: 1,
      borderColor: '#050139',
      borderRadius: 0,
      textStyle: {
        color: '#5B6770',
        align: 'left'
      }
    },
    grid: {
      left: '3%',
      right: '3%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        axisLabel: {
          fontSize: 12,
          color: '#8C959B',
          rotate: 45,
          interval: 0,
          align: 'right',
          formatter: function (param) {
            return param.replace('&amp;', '&')
          }
        },
        axisPointer: {
          type: 'shadow'
        },
        data: xaxisData
      }
    ],
    yAxis: [
      {
        type: 'value',
        axisLabel: {
          fontSize: 12,
          color: '#8C959B',
          formatter: '{value}%'
        }
      }
    ],
    series: seriesData,
    color: chartColors
  }
}

export function getSectorGraph(name, data) {
  // popoulate legend data
  const legendData = getLegendData(data)

  // get the max number of dates and populate xaxis data
  const xaxisData = getXData(data, 'sectorExposures')

  // set series values
  const seriesData = getSeriesData(data, xaxisData, 'sectorExposures', name, '100%')

  // create the chart option with data
  return {
    title: {
      text: `${name.replace('&amp;', '&')} Sector (% weight)`,
      left: 5,
      textStyle: {
        fontStyle: 'italic',
        fontWeight: 400,
        fontSize: 14,
        color: '#8c959b'
      }
    },
    tooltip: {
      trigger: 'axis',
      formatter: function (params) {
        let res = params[0].name
        for (let i = 0, l = params.length; i < l; i++) {
          if (!params[i].value) {
            continue
          }
          res += `<br/>${params[i].marker} ${params[i].seriesName} : ${params[i].value}%`
        }
        return res
      },
      backgroundColor: '#FFF',
      borderWidth: 1,
      borderColor: '#050139',
      borderRadius: 0,
      textStyle: {
        color: '#5B6770',
        align: 'left'
      }
    },
    legend: {
      itemGap: 20,
      data: legendData
    },
    grid: {
      left: '3%',
      right: '3%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: xaxisData,
      axisLabel: {
        fontSize: 12,
        color: '#8C959B',
        rotate: 45,
        align: 'right'
      }
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        formatter: '{value}%',
        fontSize: 12,
        color: '#8C959B'
      }
    },
    series: seriesData,
    color: chartColors
  }
}

export function getUniqueCountries(data) {
  const countries = data.map(fund => {
    if (fund.countryExposures) {
      return fund.countryExposures[fund.countryExposures.length - 1].keys
    } else {
      return null
    }
  })
  const allCountries = [].concat(...countries)

  const countriesValues = data.map(fund => {
    if (fund.countryExposures) {
      return fund.countryExposures[fund.countryExposures.length - 1].values
    } else {
      return null
    }
  })
  const allCountriesValues = [].concat(...countriesValues)
  const list = allCountries.map((country, i) => ({ country, countryV: allCountriesValues[i] }))
  list.sort((a, b) => (a.countryV < b.countryV ? 1 : a.countryV === b.countryV ? (a.country < b.country ? 1 : -1) : -1))
  const orderedCountries = []
  list.forEach(function (arrayItem) {
    orderedCountries.push(arrayItem.country)
  })
  return orderedCountries.filter((v, i, a) => a.indexOf(v) === i)
}

export function getCountryChart(data) {
  const legendData = getLegendData(data)
  // populate yaxisData
  const yaxisData = getUniqueCountries(data)

  const index = yaxisData.indexOf('Other')
  if (index > -1) {
    yaxisData.splice(index, 1)
    yaxisData.push('Other')
  }

  // set series data
  const seriesData = []
  for (let d = 0; d < data.length; d++) {
    if (!data[d].countryExposures) {
      continue
    }
    const countries = data[d].countryExposures[data[d].countryExposures.length - 1]
    const ticker = data[d].ticker
    const values = yaxisData.map(name => {
      const index = countries.keys.findIndex(x => x === name)
      if (index !== -1) {
        return parseFloat((countries.values[index] * 100).toFixed(2))
      } else {
        return 0
      }
    })
    seriesData.push({ name: ticker, type: 'bar', barGap: 0, data: values })
  }

  return {
    legend: {
      itemGap: 20,
      data: legendData
    },
    tooltip: {
      trigger: 'axis',
      formatter: function (params) {
        let resp = params[0].name
        for (let i = 0, l = params.length; i < l; i++) {
          resp += `<br/>${params[i].marker} ${params[i].seriesName} : ${params[i].value}%`
        }
        return resp
      },
      backgroundColor: '#FFF',
      borderWidth: 1,
      borderColor: '#050139',
      borderRadius: 0,
      textStyle: {
        color: '#5B6770',
        align: 'left'
      }
    },
    grid: {
      left: '3%',
      right: '3%',
      bottom: '3%',
      containLabel: true
    },
    yAxis: [
      {
        type: 'category',
        inverse: true,
        axisLabel: {
          fontSize: 12,
          color: '#8C959B',
          interval: 0,
          align: 'right'
        },
        axisPointer: {
          type: 'shadow'
        },
        data: yaxisData
      }
    ],
    xAxis: [
      {
        type: 'value',
        axisLabel: {
          formatter: '{value}%',
          fontSize: 12,
          color: '#8C959B'
        }
      }
    ],
    series: seriesData,
    color: chartColors
  }
}

export function getCountryGraph(name, data) {
  // popoulate legend data
  const legendData = getLegendData(data)
  // get the max number of dates and populate xaxis data
  const xaxisData = getXData(data, 'countryExposures')
  // set series values in reverse because some go back longer than others
  const seriesData = getSeriesData(data, xaxisData, 'countryExposures', name, '100%')
  // create the chart option with data
  return {
    title: {
      text: `${name} (% weight)`,
      left: 5,
      textStyle: {
        fontStyle: 'italic',
        fontWeight: 400,
        fontSize: 14,
        color: '#8c959b'
      }
    },
    tooltip: {
      trigger: 'axis',
      formatter: function (params) {
        let respo = params[0].name
        for (let i = 0, l = params.length; i < l; i++) {
          if (!params[i].value) {
            continue
          }
          respo += `<br/>${params[i].marker} ${params[i].seriesName} : ${params[i].value}%`
        }
        return respo
      },
      backgroundColor: '#FFF',
      borderWidth: 1,
      borderColor: '#050139',
      borderRadius: 0,
      textStyle: {
        color: '#5B6770',
        align: 'left'
      }
    },
    legend: {
      itemGap: 20,
      data: legendData
    },
    grid: {
      left: '3%',
      right: '3%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: xaxisData,
      axisLabel: {
        fontSize: 12,
        color: '#8C959B',
        rotate: 45,
        align: 'right'
      }
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        formatter: '{value}%',
        fontSize: 12,
        color: '#8C959B'
      }
    },
    series: seriesData,
    color: chartColors
  }
}

function currencySymbol(ccy) {
  switch (ccy) {
    case 'USD':
    case 'CAD':
      return '$'
    case 'CHF':
      return 'CHF '
    case 'EUR':
      return '€'
    default:
      return ''
  }
}

function tooltipAsType(type) {
  const append = labelAppendAsType(type)
  return {
    trigger: 'axis',
    formatter: function (params) {
      let res = params[0].name
      for (let i = 0, l = params.length; i < l; i++) {
        if (!params[i].value) {
          continue
        }
        res += `<br/>${params[i].marker} ${params[i].seriesName} : ${params[i].value}${append}`
      }
      return res
    },
    // backgroundColor: '#5B6770',
    backgroundColor: '#FFF',
    borderWidth: 1,
    borderColor: '#050139',
    borderRadius: 0,
    textStyle: {
      color: '#5B6770',
      align: 'left'
    }
  }
}

function getFactorSeries(name, rating, data) {
  const vals = data.map(x => {
    if (x.multifactorTilts) {
      const index = x.multifactorTilts[0].keys.findIndex(key => key === rating)
      if (index !== -1) {
        return Math.round(x.multifactorTilts[0].values[index] * 100)
      } else {
        return undefined
      }
    } else {
      return undefined
    }
  })

  return {
    name: name,
    type: 'bar',
    barGap: 0,
    stack: 'factor',
    data: vals,
    label: {
      normal: {
        show: true,
        position: 'inside',
        formatter: '{c}%',
        fontSize: 16,
        color: '#fff'
      }
    }
  }
}

// function getSoeFactorSeries(name, rating, data) {
//   // const vals = data.map((x) => {
//   //   if (x.multifactorTilts) {
//   //     const index = x.multifactorTilts[0].keys.findIndex((key) => key === rating);
//   //     if (index !== -1) {
//   //       return Math.round((x.multifactorTilts[0].values[index] * 100));
//   //     } else {
//   //       return undefined;
//   //     }
//   //   } else {
//   //     return undefined;
//   //   }
//   // });

//   return {
//     name: name,
//     type: 'bar',
//     barGap: 0,
//     stack: 'soe',
//     data: [88,99],
//     label: {
//       normal: {
//         show: true,
//         position: 'inside',
//         formatter: '{c}%',
//         fontSize: 16,
//       },
//     },
//   };
// }

export function getFactorChart(factor, data) {
  //name data
  const tickers = getLegendData(data)
  const seriesData = [getFactorSeries('Bad', `${factor}-Bad`, data), getFactorSeries('OK', `${factor}-OK`, data), getFactorSeries('Good', `${factor}-Good`, data)]

  // create the Factor Chart option with data
  return {
    //     legend: {
    //         itemGap: 20,
    //         data: legendData,
    //       },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      },
      formatter: function (params) {
        let res = params[0].name
        for (let i = params.length - 1; i > -1; i--) {
          res += `<br/>${params[i].marker} ${params[i].seriesName} : ${params[i].value}%`
        }
        return res
      },
      backgroundColor: '#FFF',
      borderWidth: 1,
      borderColor: '#050139',
      borderRadius: 0,
      textStyle: {
        color: '#5B6770',
        align: 'left'
      }
    },
    grid: {
      top: '3%',
      left: '3%',
      right: '3%',
      bottom: '5%',
      containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        data: tickers,
        axisLabel: {
          fontSize: 12,
          color: '#8C959B'
        }
      }
    ],
    yAxis: [
      {
        max: 100,
        type: 'value',
        axisLabel: {
          formatter: '{value}%',
          fontSize: 12,
          color: '#8C959B'
        },
        splitLine: {
          show: false
        }
      }
    ],
    series: seriesData,
    color: ['#0047BB', '#050139', '#8C959B']
  }
}

export function getFactorChart2(factor, data) {
  //name data
  const tickers = getLegendData(data)
  const seriesData = [getFactorSeries('Bad', `${factor}-Bad`, data), getFactorSeries('OK', `${factor}-OK`, data), getFactorSeries('Good', `${factor}-Good`, data)]

  // create the Factor Chart option with data
  return {
    //     legend: {
    //         itemGap: 20,
    //         data: legendData,
    //       },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      },
      formatter: function (params) {
        let res = params[0].name
        for (let i = params.length - 1; i > -1; i--) {
          res += `<br/>${params[i].marker} ${params[i].seriesName} : ${params[i].value}%`
        }
        return res
      },
      backgroundColor: '#FFF',
      borderWidth: 1,
      borderColor: '#050139',
      borderRadius: 0,
      textStyle: {
        color: '#5B6770',
        align: 'left'
      }
    },
    grid: {
      top: '3%',
      left: '3%',
      right: '3%',
      bottom: '5%',
      containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        data: tickers,
        axisLabel: {
          fontSize: 12,
          color: '#8C959B'
        }
      }
    ],
    yAxis: [
      {
        max: 100,
        type: 'value',
        axisLabel: {
          formatter: '{value}%',
          fontSize: 12,
          color: '#8C959B'
        },
        splitLine: {
          show: false
        }
      }
    ],
    series: seriesData,
    color: ['#0047BB', '#050139', '#8C959B']
  }
}

export function getMarketCapChart(data) {
  // popoulate legend data
  const legendData = getLegendData(data)

  // populate xaxisData
  const MarketCap = data.map(fund => {
    if (fund.marketCapExposures) {
      return fund.marketCapExposures[fund.marketCapExposures.length - 1].keys
    } else {
      return null
    }
  })

  const allMarketCap = [].concat(...MarketCap)
  const uniqueMarketCap = allMarketCap.filter((v, i, a) => a.indexOf(v) === i)
  const xaxisData = [...uniqueMarketCap].sort()
  const seriesData = []
  let xaxisDataFormat = []
  for (let d = 0; d < data.length; d++) {
    if (!data[d].marketCapExposures) {
      continue
    }
    const mkts = data[d].marketCapExposures[data[d].marketCapExposures.length - 1]
    const ticker = data[d].ticker
    const values = xaxisData.map(name => {
      const index = mkts.keys.findIndex(x => x === name)
      if (index !== -1) {
        return parseFloat((mkts.values[index] * 100).toFixed(2))
      } else {
        return 0
      }
    })
    xaxisDataFormat = xaxisData.map(name => {
      if (name === 'largeCap') {
        return 'Large Cap'
      } else if (name === 'midCap') {
        return 'Mid Cap'
      } else if (name === 'smallCap') {
        return 'Small Cap'
      } else {
        return name
      }
    })
    seriesData.push({ name: ticker, type: 'bar', barGap: 0, data: values })
  }
  //console.log ('MARKETCAP DATA',seriesData)
  // create the market Cap chart option with data
  return {
    legend: {
      itemGap: 20,
      data: legendData
    },
    tooltip: {
      trigger: 'axis',
      formatter: function (params) {
        let res = params[0].name
        for (let i = 0, l = params.length; i < l; i++) {
          res += `<br/>${params[i].marker} ${params[i].seriesName} : ${params[i].value}%`
        }
        return res
      },
      backgroundColor: '#FFF',
      borderWidth: 1,
      borderColor: '#050139',
      borderRadius: 0,
      textStyle: {
        color: '#5B6770',
        align: 'left'
      }
    },
    grid: {
      top: '3%',
      left: '3%',
      right: '3%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        axisLabel: {
          fontSize: 12,
          color: '#8C959B',
          interval: 0,
          formatter: function (param) {
            return param.replace('&amp;', '&')
          }
        },
        axisPointer: {
          type: 'shadow'
        },
        data: xaxisDataFormat
      }
    ],
    yAxis: [
      {
        type: 'value',
        axisLabel: {
          fontSize: 12,
          color: '#8C959B',
          formatter: '{value}%'
        }
      }
    ],
    series: seriesData,
    color: chartColors
  }
}

export function getRegionChart(data) {
  // popoulate legend data
  const legendData = getLegendData(data)

  // populate xaxisData
  const RegionExp = data.map(fund => {
    if (fund.regionExposures) {
      return fund.regionExposures[fund.regionExposures.length - 1].keys
    } else {
      return null
    }
  })

  const allRegionExp = [].concat(...RegionExp)
  const uniqueRegionExp = allRegionExp.filter((v, i, a) => a.indexOf(v) === i)
  const xaxisData = [...uniqueRegionExp].sort()
  const seriesData = []
  let xaxisDataFormat = []
  for (let d = 0; d < data.length; d++) {
    if (!data[d].regionExposures) {
      continue
    }
    const mkts = data[d].regionExposures[data[d].regionExposures.length - 1]
    const ticker = data[d].ticker
    const values = xaxisData.map(name => {
      const index = mkts.keys.findIndex(x => x === name)
      if (index !== -1) {
        return parseFloat((mkts.values[index] * 100).toFixed(2))
      } else {
        return 0
      }
    })
    xaxisDataFormat = xaxisData.map(name => {
      if (name === 'US') {
        return 'United States'
      } else if (name === 'DM') {
        return 'Developed'
      } else if (name === 'EM') {
        return 'Emerging'
      } else {
        return name
      }
    })
    seriesData.push({ name: ticker, type: 'bar', barGap: 0, data: values })
  }

  // create the chart option with data
  return {
    legend: {
      itemGap: 20,
      data: legendData
    },
    tooltip: {
      trigger: 'axis',
      formatter: function (params) {
        let res = params[0].name
        for (let i = 0, l = params.length; i < l; i++) {
          res += `<br/>${params[i].marker} ${params[i].seriesName} : ${params[i].value}%`
        }
        return res
      },
      backgroundColor: '#FFF',
      borderWidth: 1,
      borderColor: '#050139',
      borderRadius: 0,
      textStyle: {
        color: '#5B6770',
        align: 'left'
      }
    },
    grid: {
      left: '3%',
      right: '3%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        axisLabel: {
          fontSize: 12,
          color: '#8C959B',
          interval: 0,
          rotate: 45,
          margin: 10,         
          formatter: function (param) {
            return param.replace('&amp;', '&')
          }
        },
        axisPointer: {
          type: 'shadow'
        },
        data: xaxisDataFormat
      }
    ],
    yAxis: [
      {
        type: 'value',
        axisLabel: {
          fontSize: 12,
          color: '#8C959B',
          formatter: '{value}%'
        }
      }
    ],
    series: seriesData,
    color: chartColors
  }
}

export function getMaturityChart(data) {
  // populate legend data
  const legendData = getLegendData(data)

  // populate xaxisData
  const MaturityProfile = data.map(fund => {
    if (fund.maturityExposures && fund.maturityExposures.length > 0) {
      return fund.maturityExposures[fund.maturityExposures.length - 1].keys
    } else {
      return null
    }
  })
  const sortOrder = ['Less than 1 Year', '1 to 3 Years', '3 to 5 Years', '5 to 10 Years', '10 to 20 Years', '20 to 30 Years', 'Greater than 30 Years']
  const allMaturityProfile = [].concat(...MaturityProfile)
  const uniqueMaturityProfile = allMaturityProfile.filter((v, i, a) => a.indexOf(v) === i)
  const xaxisData = [...uniqueMaturityProfile].sort(function (a, b) {
    if (a === b) {
      return a.localeCompare(b)
    } else {
      return sortOrder.indexOf(a) - sortOrder.indexOf(b)
    }
  })

  const seriesData = []
  for (let d = 0; d < data.length; d++) {
    if (!data[d].maturityExposures) {
      continue
    }
    const mats = data[d].maturityExposures[data[d].maturityExposures.length - 1]
    const ticker = data[d].ticker
    const values = xaxisData.map(name => {
      if (mats && mats.keys) {
        const index = mats.keys.findIndex(x => x === name)
        if (index !== -1) {
          return parseFloat((mats.values[index] * 100).toFixed(2))
        } else {
          return 0
        }
      } else {
        return 0
      }
    })
    // Check if values is not null, not empty, and not all zeros
    if (values && values.length && !values.every(val => val === 0)) {
      seriesData.push({ name: ticker, type: 'bar', barGap: 0, data: values })
    }
  }

  // create the chart option with data
  return {
    legend: {
      itemGap: 20,
      data: legendData
    },
    tooltip: {
      trigger: 'axis',
      formatter: function (params) {
        let res = params[0].name
        for (let i = 0, l = params.length; i < l; i++) {
          res += `<br/>${params[i].marker} ${params[i].seriesName} : ${params[i].value}%`
        }
        return res
      },
      backgroundColor: '#FFF',
      borderWidth: 1,
      borderColor: '#050139',
      borderRadius: 0,
      textStyle: {
        color: '#5B6770',
        align: 'left'
      }
    },
    grid: {
      left: '3%',
      right: '3%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        axisLabel: {
          fontSize: 12,
          color: '#8C959B',
          interval: 0,
          formatter: function (param) {
            return param.replace('&amp;', '&')
          }
        },
        axisPointer: {
          type: 'shadow'
        },
        data: xaxisData
      }
    ],
    yAxis: [
      {
        type: 'value',
        axisLabel: {
          fontSize: 12,
          color: '#8C959B',
          formatter: '{value}%'
        }
      }
    ],
    series: seriesData,
    color: chartColors
  }
}

export function getCreditQualityChart(data) {
  // popoulate legend data
  const legendData = getLegendData(data)

  // populate xaxisData
  const CreditProfile = data.map(fund => {
    if (fund.creditQualityExposures && fund.creditQualityExposures.length > 0) {
      return fund.creditQualityExposures[fund.creditQualityExposures.length - 1].keys
    } else {
      return null
    }
  })
  const sortOrder = ['AAA', 'AA', 'A', 'BBB', 'BB', 'B', 'CCC', 'CC', 'C & Below', 'Cash', 'Other', 'N/R', 'NR']
  const allCreditQuality = [].concat(...CreditProfile)
  const uniqueCreditQuality = allCreditQuality.filter((v, i, a) => a.indexOf(v) === i)
  const xaxisData = [...uniqueCreditQuality].sort(function (a, b) {
    if (a === b) {
      return a.localeCompare(b)
    } else {
      return sortOrder.indexOf(a) - sortOrder.indexOf(b)
    }
  })

  const seriesData = []
  for (let d = 0; d < data.length; d++) {
    if (!data[d].creditQualityExposures) {
      continue
    }
    const credits = data[d].creditQualityExposures[data[d].creditQualityExposures.length - 1]
    const ticker = data[d].ticker
    const values = xaxisData.map(name => {
      if (credits && credits.keys && credits.values) {
        const index = credits.keys.findIndex(x => x === name)
        if (index !== -1) {
          return parseFloat((credits.values[index] * 100).toFixed(2))
        } else {
          return 0
        }
      } else {
        return 0
      }
    })
    if (values && values.length > 0) {
      seriesData.push({ name: ticker, type: 'bar', barGap: 0, data: values })
    }
  }

  // create the chart option with data
  return {
    legend: {
      itemGap: 20,
      data: legendData
    },
    tooltip: {
      trigger: 'axis',
      formatter: function (params) {
        let res = params[0].name
        for (let i = 0, l = params.length; i < l; i++) {
          res += `<br/>${params[i].marker} ${params[i].seriesName} : ${params[i].value}%`
        }
        return res
      },
      backgroundColor: '#FFF',
      borderWidth: 1,
      borderColor: '#050139',
      borderRadius: 0,
      textStyle: {
        color: '#5B6770',
        align: 'left'
      }
    },
    grid: {
      left: '3%',
      right: '3%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        axisLabel: {
          fontSize: 12,
          color: '#8C959B',
          interval: 0,
          formatter: function (param) {
            return param.replace('&amp;', '&')
          }
        },
        axisPointer: {
          type: 'shadow'
        },
        data: xaxisData
      }
    ],
    yAxis: [
      {
        type: 'value',
        axisLabel: {
          fontSize: 12,
          color: '#8C959B',
          formatter: '{value}%'
        }
      }
    ],
    series: seriesData,
    color: chartColors
  }
}

export function getAssetClassChart(data) {
  // popoulate legend data
  const legendData = getLegendData(data)

  // populate xaxisData
  const AssetClass = data.map(fund => {
    if (fund.assetClassExposures) {
      return fund.assetClassExposures[fund.assetClassExposures.length - 1].keys
    } else {
      return null
    }
  })
  const allAssetClass = [].concat(...AssetClass)
  const uniqueAssetClass = allAssetClass.filter((v, i, a) => a.indexOf(v) === i)
  const xaxisData = [...uniqueAssetClass].sort()

  const seriesData = []
  for (let d = 0; d < data.length; d++) {
    if (!data[d].assetClassExposures) {
      continue
    }
    const assets = data[d].assetClassExposures[data[d].assetClassExposures.length - 1]
    const ticker = data[d].ticker
    const values = xaxisData.map(name => {
      const index = assets.keys.findIndex(x => x === name)
      if (index !== -1) {
        return parseFloat((assets.values[index] * 100).toFixed(2))
      } else {
        return 0
      }
    })
    seriesData.push({ name: ticker, type: 'bar', barGap: 0, data: values })
  }

  // create the chart option with data
  return {
    legend: {
      itemGap: 20,
      data: legendData
    },
    tooltip: {
      trigger: 'axis',
      formatter: function (params) {
        let res = params[0].name
        for (let i = 0, l = params.length; i < l; i++) {
          res += `<br/>${params[i].marker} ${params[i].seriesName} : ${params[i].value}%`
        }
        return res
      },
      backgroundColor: '#FFF',
      borderWidth: 1,
      borderColor: '#050139',
      borderRadius: 0,
      textStyle: {
        color: '#5B6770',
        align: 'left'
      }
    },
    grid: {
      left: '3%',
      right: '3%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        axisLabel: {
          fontSize: 12,
          color: '#8C959B',
          interval: 0,
          formatter: function (param) {
            return param.replace('&amp;', '&')
          }
        },
        axisPointer: {
          type: 'shadow'
        },
        data: xaxisData
      }
    ],
    yAxis: [
      {
        type: 'value',
        axisLabel: {
          fontSize: 12,
          color: '#8C959B',
          formatter: '{value}%'
        }
      }
    ],
    series: seriesData,
    color: chartColors
  }
}
//Performance Correlation
export function getCorrelationChart(funds) {
  const originalLabelsX = funds[0].correlations?.keys;
  const originalLabelsY = funds[0].correlations?.keys?.slice().reverse();

  const labelsX = originalLabelsX?.map(label => trimKey(label, 10));
  const labelsY = originalLabelsY?.map(label => trimKey(label, 10));

  const data = []
  for (let x = 0; x < funds.length; x++) {
    let yCnt = 0
    for (let y = funds[x].correlations.values.length - 1; y >= 0; y--) {
      data.push([x, yCnt, funds[x].correlations.values[y].toFixed(2)])
      yCnt++
    }
  }

  return {
    grid: {
      top: '3%',
      left: '0%',
      right: '0%',
      bottom: '5%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: labelsX,
      axisTick: {
        show: false
      },
      axisLine: {
        show: false
      },
      axisLabel: {
        fontSize: 14,
        color: '#5b6770',
        margin: 10,      
        formatter: function (value) {
          return value.toUpperCase();
        }          
      },
      position: 'top'
    },
    yAxis: {
      type: 'category',
      data: labelsY,
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        fontSize: 14,
        color: '#5b6770',
        formatter: function (value) {
          return value.toUpperCase();
        }          
      }
    },
    visualMap: {
      type: 'piecewise',
      splitNumber: 20,
      min: -1,
      max: 1,
      calculable: true,
      show: false,
      inRange: {
        // color: ['#8c959b', '#0047BB','#050139'],
        color: ['#8c959b', '#0047BB']
      }
    },
    itemStyle: {
      borderWidth: 2,
      borderColor: '#FFF'
    },
    series: [
      {
        name: 'Correlation',
        type: 'heatmap',
        data: data,
        label: {
          show: true,
          fontSize: 20,
          color: '#fff'
        }
      }
    ],
    tooltip: {
      position: 'top',
      formatter: function (params) {
        const labelX = originalLabelsX[params.data[0]].toUpperCase();
        const labelY = originalLabelsY[params.data[1]].toUpperCase();
        return `${labelX} - ${labelY}: ${params.data[2]}`;
      }
    }  
  }
}

//Holding Weights in Common
export function getHoldingsOverlapChart(funds) {
  const originalLabelsX = funds[0].overlaps?.keys;
  const originalLabelsY = funds[0].overlaps?.keys?.slice().reverse();

  const labelsX = originalLabelsX?.map(label => trimKey(label, 10));
  const labelsY = originalLabelsY?.map(label => trimKey(label, 10));

  const totalHoldings = []
  const data = []

  const newLabelsX = []
  const newLabelsY = []

  for (let x = 0; x < funds.length; x++) {
    let yCnt = 0
    for (let y = funds[x].overlaps.values.length - 1; y >= 0; y--) {
      data.push([x, yCnt, Math.round(100 * funds[x].overlaps.values[y])])
      yCnt++
    }
    totalHoldings.push(funds[x].topHoldings?.keys?.length)
  }

  let totalHoldingsReversed = totalHoldings?.slice()?.reverse()
 

  labelsX?.forEach((f, index) => {
    const thold = totalHoldings[index]
    newLabelsX.push(f + ' (' + thold + ') ')
  })

  labelsY?.forEach((f, index) => {
    const thold = totalHoldingsReversed[index]
    newLabelsY.push(f + ' (' + thold + ') ')
  })

  return {
    grid: {
      top: '3%',
      left: '0%',
      right: '0%',
      bottom: '5%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: labelsX,
      axisTick: {
        show: false
      },
      axisLine: {
        show: true
      },
      axisLabel: {
        fontSize: 14,
        color: '#5b6770',
        margin: 10,
        formatter: function (value) {
          return value.toUpperCase();
        }   
      },
      position: 'top'
    },
    yAxis: {
      type: 'category',
      data: labelsY,
      axisLine: {
        show: true
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        fontSize: 14,
        color: '#5b6770',
        formatter: function (value) {
          return value.toUpperCase();
        }          
      }
    },
    visualMap: {
      type: 'piecewise',
      splitNumber: 25,
      min: 0,
      max: 100,
      calculable: true,
      show: false,
      inRange: {
        color: ['#8c959b', '#0047BB']
      }
    },
    itemStyle: {
      borderWidth: 2,
      borderColor: '#FFF'
    },
    series: [
      {
        name: 'Holdings Overlaps',
        type: 'heatmap',
        data: data,
        label: {
          show: true,
          fontSize: 20,
          formatter: function (params) {
            return `${params.value[2]}%`
          },
          color: '#fff'
        }
      }
    ],
    tooltip: {
      position: 'top',
      formatter: function (params) {
        const labelX = originalLabelsX[params.data[0]].toUpperCase();
        const labelY = originalLabelsY[params.data[1]].toUpperCase();
        return `${labelX} - ${labelY}: ${params.data[2]}`;
      }
    }     
  }
}
//Holding Counts in common
export function getHoldingsOverlapCountChart(funds) {
  const originalLabelsX = funds[0].overlaps?.keys;
  const originalLabelsY = funds[0].overlaps?.keys?.slice().reverse();


  const labelsX = originalLabelsX?.map(label => trimKey(label, 10));
  const labelsY = originalLabelsY?.map(label => trimKey(label, 10)); 

  // const labelsXCounts = funds[0].overlapsCount.keys;
  // const labelsYCounts = funds[0].overlapsCount.keys.slice().reverse();
  const totalHoldings = []
  const data = []
  let maxChart = 0
  const newLabelsX = []
  const newLabelsY = []

  for (let x = 0; x < funds.length; x++) {
    let maxValue = Math.max(...funds[x].overlapsCount.values)

    let yCnt = 0
    for (let y = funds[x].overlapsCount.values.length - 1; y >= 0; y--) {
      data.push([x, yCnt, funds[x].overlapsCount.values[y]])
      yCnt++
    }
    totalHoldings.push(funds[x].topHoldings?.keys?.length)
    if (maxValue >= maxChart) {
      maxChart = maxValue
    }
  }

  let totalHoldingsReversed = totalHoldings?.slice()?.reverse()

  labelsX?.forEach((f, index) => {
    const thold = totalHoldings[index]
    newLabelsX.push(f + ' (' + thold + ') ')
  })

  labelsY?.forEach((f, index) => {
    const thold = totalHoldingsReversed[index]
    newLabelsY.push(f + ' (' + thold + ') ')
  })

  return {
    grid: {
      top: '3%',
      left: '0%',
      right: '0%',
      bottom: '5%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: labelsX,
      axisTick: {
        show: false
      },
      axisLine: {
        show: true
      },
      axisLabel: {
        fontSize: 14,
        color: '#5b6770',
        margin: 10,
        formatter: function (value) {
          return value.toUpperCase();
        }        
      },
      position: 'top'
    },
    yAxis: {
      type: 'category',
      data: labelsY,
      axisLine: {
        show: true
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        fontSize: 14,
        color: '#5b6770',
        formatter: function (value) {
          return value.toUpperCase();
        }          
      }
    },
    visualMap: {
      type: 'piecewise',
      splitNumber: 25,
      min: 0,
      max: maxChart,
      calculable: true,
      show: false,
      inRange: {
        color: ['#8c959b', '#0047BB']
      }
    },
    itemStyle: {
      borderWidth: 2,
      borderColor: '#FFF'
    },
    series: [
      {
        name: 'Holdings Overlaps',
        type: 'heatmap',
        data: data,
        label: {
          show: true,
          fontSize: 20,
          color: '#fff'
          // formatter: function (params) {
          //   return `${params.value[2]}%`;
          // },
        }
      }
    ],
    tooltip: {
      position: 'top',
      formatter: function (params) {
        const labelX = originalLabelsX[params.data[0]].toUpperCase();
        const labelY = originalLabelsY[params.data[1]].toUpperCase();
        return `${labelX} - ${labelY}: ${params.data[2]}`;
      }
    }      
  }
}
//Relative to first selected fund?
export function getHoldingsOverlapRelativeLeftChart(funds) {
  const originalLabelsX = funds[0].overlaps?.keys;
  const originalLabelsY = funds[0].overlaps?.keys?.slice().reverse();

  if (!originalLabelsX) {
    return null
  }
  
  
  const labelsX = originalLabelsX?.map(label => trimKey(label, 10));
  const labelsY = originalLabelsY?.map(label => trimKey(label, 10)); 

  const data = []

  for (let x = 0; x < funds.length; x++) {
    let yCnt = 0
    for (let y = funds[x].overlapsWeightLeft.values.length - 1; y >= 0; y--) {
      data.push([x, yCnt, Math.round(100 * funds[x].overlapsWeightLeft.values[y])])
      yCnt++
    }
  }
  return {
    grid: {
      top: '3%',
      left: '0%',
      right: '0%',
      bottom: '5%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: labelsX,
      axisTick: {
        show: false
      },
      axisLine: {
        show: true
      },
      axisLabel: {
        fontSize: 14,
        color: '#5b6770',
        margin: 10,
        formatter: function (value) {
          return value.toUpperCase();
        }   
      },
      position: 'top'
    },
    yAxis: {
      type: 'category',
      data: labelsY,
      axisLine: {
        show: true
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        fontSize: 14,
        color: '#5b6770',
        formatter: function (value) {
          return value.toUpperCase();
        }          
      }
    },
    visualMap: {
      type: 'piecewise',
      splitNumber: 25,
      min: 0,
      max: 100,
      calculable: true,
      show: false,
      inRange: {
        color: ['#8c959b', '#0047BB']
      }
    },
    itemStyle: {
      borderWidth: 2,
      borderColor: '#FFF'
    },
    series: [
      {
        name: 'Holdings Overlaps',
        type: 'heatmap',
        data: data,
        label: {
          show: true,
          fontSize: 20,
          formatter: function (params) {
            return `${params.value[2]}%`
          },
          color: '#fff'
        }
      }
    ],
    tooltip: {
      position: 'top',
      formatter: function (params) {
        const labelX = originalLabelsX[params.data[0]];
        const labelY = originalLabelsY[params.data[1]];
        return `${labelX} - ${labelY}: ${params.data[2]}`;
      }
    }      
  }
}
//relative to?
export function getHoldingsOverlapRelativeRightChart(funds) {
  const originalLabelsX = funds[0].correlations?.keys;

  if (!originalLabelsX) {
    return null
  }
  
  const originalLabelsY = funds[0].correlations?.keys?.slice().reverse();
  const labelsX = originalLabelsX?.map(label => trimKey(label, 10));
  const labelsY = originalLabelsY?.map(label => trimKey(label, 10)); 
  const dataRight = []

  for (let x = 0; x < funds.length; x++) {
    let yCnt = 0
    for (let y = funds[x].overlapsWeightRight.values.length - 1; y >= 0; y--) {
      dataRight.push([x, yCnt, Math.round(100 * funds[x].overlapsWeightRight.values[y])])
      yCnt++
    }
  }
  //console.log ('dataRight',dataRight)
  return {
    grid: {
      top: '3%',
      left: '0%',
      right: '0%',
      bottom: '5%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: labelsX,
      axisTick: {
        show: false
      },
      axisLine: {
        show: true
      },
      axisLabel: {
        fontSize: 14,
        color: '#5b6770',
        margin: 10,
        formatter: function (value) {
          return value.toUpperCase();
        }          
      },
      position: 'top'
    },
    yAxis: {
      type: 'category',
      data: labelsY,
      axisLine: {
        show: true
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        fontSize: 14,
        color: '#5b6770',
        formatter: function (value) {
          return value.toUpperCase();
        }          
      }
    },
    visualMap: {
      type: 'piecewise',
      splitNumber: 25,
      min: 0,
      max: 100,
      calculable: true,
      show: false,
      inRange: {
        color: ['#8c959b', '#0047BB']
      }
    },
    itemStyle: {
      borderWidth: 2,
      borderColor: '#FFF'
    },
    series: [
      {
        name: 'Holdings Overlaps',
        type: 'heatmap',
        data: dataRight,
        label: {
          show: true,
          fontSize: 20,
          color: '#fff'
          // formatter: function (params) {
          //   return `${params.value[2]}%`;
          // },
        }
      }
    ],
    tooltip: {
      position: 'top',
      formatter: function (params) {
        const labelX = originalLabelsX[params.data[0]];
        const labelY = originalLabelsY[params.data[1]];
        return `${labelX} - ${labelY}: ${params.data[2]}`;
      }
    }      
  }
}

// export function getHoldingsRelativeOverlapCountChart(funds) {

//   const labelsX = funds[0].overlaps.keys;
//   const labelsY = funds[0].overlaps.keys.slice().reverse();
//   const labelsXCounts = funds[0].overlapsCount.keys;
//   const labelsYCounts = funds[0].overlapsCount.keys.slice().reverse();
//   const totalHoldings=[];
//   const data = [];
//   let maxChart =0;
//   const newLabelsX = [];
//   const newLabelsY =[];

//    for (let x = 0; x < funds.length; x++) {
//     let maxValue = Math.max(...funds[x].overlapsCount.values);
//     console.log ('allVals', maxValue)
//     let yCnt = 0;
//     for (let y = funds[x].overlapsCount.values.length - 1; y >= 0; y--) {
//       data.push([x, yCnt, funds[x].overlapsCount.values[y]]);
//       yCnt++;
//     }
//     totalHoldings.push(funds[x].topHoldings.keys.length)
//     if (maxValue >= maxChart){
//       maxChart= maxValue

//     }
//   }

//   let totalHoldingsReversed =  totalHoldings.slice().reverse();

//   return {
//     grid: {
//       top: '3%',
//       left: '0%',
//       right: '0%',
//       bottom: '5%',
//       containLabel: true,
//     },
//     xAxis: {
//       type: 'category',
//       data: newLabelsX,
//       axisTick: {
//         show: false
//       },
//       axisLine: {
//         show: true
//       },
//       axisLabel: {
//         fontSize: 14,
//         color: '#5b6770',
//       },
//       position: 'top',
//     },
//     yAxis: {
//       type: 'category',
//       data: newLabelsY,
//       axisLine: {
//         show: true
//       },
//       axisTick: {
//         show: false
//       },
//       axisLabel: {
//         fontSize: 14,
//         color: '#5b6770',
//       },
//     },
//     visualMap: {
//       type: 'piecewise',
//       splitNumber: 25,
//       min: 0,
//       max: maxChart,
//       calculable: true,
//       show: false,
//       inRange: {
//         // color: [ '#b2c68d', '#83a348', '#3c5410', '#466212', '#507015' ,'#5a7e18' ,'#658D1B'],
//         color: ['#84344E', '#8c959b', '#658D1B'], //same as performance
//       },
//     },
//     itemStyle: {
//       borderWidth: 2,
//       borderColor: '#FFF'
//     },
//     series: [{
//       name: 'Holdings Overlaps',
//       type: 'heatmap',
//       data: data,
//       label: {
//         show: true,
//         fontSize: 20,
//         // formatter: function (params) {
//         //   return `${params.value[2]}%`;
//         // },
//       },
//     }]
//   };
// }
